import React, {
  Component,
} from 'react';
import {
  Gmaps, Marker,
} from 'react-gmaps';
import classes from './MapContainer.module.scss';

const params = {
  v: '3.exp', key: 'AIzaSyAC1kD_cNz3nZnhHwRmZL4Zg5jkSCqaqXc',
};

interface IProps {
  markPosition: {
    latitude: number;
    longitude: number;
  };
  onMarkDrag(latitude: number, longitude: number): void;
}

interface State {
  latitude: number;
  longitude: number;
}

export class MapContainer extends Component<IProps, State> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      latitude: this.props.markPosition.latitude,
      longitude: this.props.markPosition.longitude,
    };
  }

  onMapCreated(map: any) {
    map.setOptions({
      disableDefaultUI: false,
    });
  }

  onDragEnd = (e: any) => {
    this.props.onMarkDrag(e.latLng.lat(), e.latLng.lng());
  };

  render() {
    return (
      <Gmaps
        className={classes.mapContainer}
        borderRadius="5px"
        width="100%"
        height="100%"
        lat={this.state.latitude}
        lng={this.state.longitude}
        zoom={15}
        loadingMessage="Be happy"
        params={params}
        onMapCreated={this.onMapCreated}
      >
        <Marker
          lat={this.state.latitude}
          lng={this.state.longitude}
          draggable
          onDragEnd={this.onDragEnd}
        />
      </Gmaps>
    );
  }
}

export default MapContainer;
